import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./logo.module.scss";

export const Logo = ({
    type = "primary",
    opticalAlign = "none",
    className,
    ...props
}: {
    type?: "primary" | "secondary";
    /**
     * Whether to add visual space on top of the letters such that the center of the text runs along the center of the svg
     */
    opticalAlign?: "center" | "none";
} & React.HTMLAttributes<SVGSVGElement>) => {
    const offsetTop = opticalAlign === "center" ? -28 : 0;
    const height = 80 - offsetTop;
    switch (type) {
        case "primary":
            return (
                <svg
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox={`0 ${offsetTop} 402 ${height}`}
                    className={concatClassNames([styles.logo, className])}
                >
                    <path
                        fill="currentColor"
                        d="M11.617 42.628H37.95v10.56H0V.377h11.617zm90.007-31.91H73.329v10.71h24.902v10.337H73.33v11.09h28.672v10.333H61.789V.377h39.835zm77.253 42.47h-12.144l-4.828-11.845h-22.331l-4.828 11.844h-11.845L145.532 0h10.709zm58.696-20.293V.377h11.473v52.81h-9.883L213.585 19.62v33.567h-11.469V.377h10.709zm88.953 20.292h-11.612V.377h11.612zm63.896-20.291V.377h11.468v52.81h-9.877L366.438 19.62v33.567h-11.467V.377h10.704zM143.72 31.088h14.034l-7.017-17.126z"
                    />
                    <path
                        fill="var(--accent)"
                        d="M401.89 76.422h-86.976V80h86.976z"
                    />
                </svg>
            );
        case "secondary":
            return (
                <svg
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox={`0 ${offsetTop} 87 ${height}`}
                    className={concatClassNames([styles.logo, className])}
                >
                    <path
                        d="M11.6123 0.376953V53.1875H0V0.376953H11.6123ZM75.5078 32.8955V0.376953H86.9756V53.1875H77.0986L51.5244 19.6201V53.1875H40.0566V0.376953H50.7607L75.5078 32.8955Z"
                        fill="currentColor"
                    />
                    <path
                        d="M86.9755 76.4219H0.000244141V80H86.9755V76.4219Z"
                        fill="var(--accent)"
                    />
                </svg>
            );
    }
};
